<template>
    <ModalFormCard class="modal-default" :action='"/page-templates/order"'>
        <template #title>Manage views</template>

        <template #default="{ saving, errors }">
            <input v-for='t in templates' type='hidden' :name='"page_templates["+t.id+"]"' />
            <input name='page_id' type='hidden' :value='options.page_id' />

            <div class=''>
                <p v-if='templates.length == 0' class='text-15'>You don't have any templates to manage yet</p>

                <draggable v-model='templates' group='reviews' @start="drag=true" @end="drag=false" item-key="id"
                    handle=".handle" @change='updateOrder'
                    class='grid grid-cols-1 gap-x-10 gap-y-4'
                >
                    <template #item="{element}">
                        <div class='border border-grey-500 bg-grey-300 flex items-center p-3 text-15'>
                            <IconList class='w-4.5 h-4.5 stroke-black handle hover:cursor-pointer hover:stroke-grey-700' />
                            <p class='w-full px-4'>{{ element.name }}</p>

                            <DropdownV2 forceSide='right'>
                                <template #button>
                                    <IconAdditionalSettings class='w-4.5 h-4.5 fill-back stroke-black' />
                                </template>
                                <template #menu>
                                    <div class="table-multi-select-menu bg-black min-w-[160px]">
                                        <button type='button' @click='$pop("TableCreateView", {
                                            editingModel: element,
                                            options: {
                                                templates: options.templates
                                            }
                                        })'>Edit</button>
                                        <button type='button' @click="deleteTemplate(element)">Delete</button>
                                    </div>
                                </template>
                            </DropdownV2>
                        </div>
                    </template>
                </draggable>
            </div>

            <div class="modal-buttons pt-6">
                <ButtonSaving v-if='templates.length > 0' :disabled="saving" class="default button-black h-12 px-6">
					Save views
				</ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'
    import draggable from 'vuedraggable'

    export default {
        mixins: [Modal],

        data() {
            return {
                templates: []
            }
        },

        created() {
            this.templates = []

            for (const [key, value] of Object.entries(this.options.templates)) {
                if (value != null && typeof value == 'object') {
                    this.templates.push(value)
                }
            }
        },

        methods: {
            updateOrder() {
                this.templates.map((r, i) => ({ id: r.id, order: i }))
            },

            deleteTemplate(template) {
                this.$event.$emit('modal-open', {
                    view: 'Confirm',
                    options: {
                        message: 'Are you sure you want delete the view '+template.name+'.',
                        button: 'Delete view',
                        submitFunction: () => {
                            this.$axios.delete('/page-template/' + template.id)
                                .then(res => {
                                    delete this.options.templates[template.name]

                                    this.$pop("TableManageViews", {
                                        options: {
                                            templates: this.options.templates
                                        }
                                    })
                                })
                        }
                    },
                })
            }
        },  

        computed: {
        },

        components: {
            draggable
        }
    }
</script>